import Chip from '@mui/material/Chip';
import { FormattedMessage } from 'react-intl';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Box from '@mui/material/Box';
import { DataType } from 'csstype';
import { PlanInterval, SubscriptionSource } from '../../../models';

export const BillingCycle = (
  { source, billingInterval, useChip, shortName, position, padding }: {
    source: SubscriptionSource,
    billingInterval: PlanInterval,
    useChip?: boolean,
    shortName?: boolean,
    position?: DataType.ContentPosition,
    padding?: {
      pt?: number,
      pb?: number,
      pl?: number,
      pr?: number,
    }
  },
) => {
  const renderBillingCycle = (source: SubscriptionSource, billingInterval: PlanInterval) => {
    if (source === SubscriptionSource.TRIAL_REQUEST) {
      return (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent={position ?? 'center'}
          paddingBottom={padding?.pb ?? 1}
        >
          <Box
            component="span"
            paddingRight={1}
            display="flex"
          >
            <CalendarMonthIcon />
          </Box>
          <FormattedMessage id={`page.subscription.billing.interval.year${shortName ? '.short' : ''}`} />
        </Box>
      );
    }

    return (
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={position ?? 'center'}
        paddingBottom={padding?.pb ?? 1}
        paddingRight={padding?.pr ?? 1}
        paddingLeft={padding?.pl ?? 0}
        paddingTop={padding?.pt ?? 0}
      >
        <Box
          component="span"
          paddingRight={1}
          display="flex"
        >
          <CalendarMonthIcon />
        </Box>
        {billingInterval
          ? <FormattedMessage id={`page.subscription.billing.interval.${billingInterval.toLowerCase()}${shortName ? '.short' : ''}`} />
          : <FormattedMessage id="page.subscription.billing.interval.unknown" />}
      </Box>
    );
  };

  return useChip ? (
    <Chip
      label={renderBillingCycle(source, billingInterval)}
      sx={theme => ({
        height: theme.spacing(3.5),
        padding: theme.spacing(0.5, 0),
        borderRadius: theme.borderRadius.radiusRounded4px,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: position ?? 'center',
        backgroundColor: source === SubscriptionSource.TRIAL_REQUEST
          ? theme.refV2.cat.purple[900]
          : theme.refV2.sem.green[900],
        '& .MuiChip-label': {
          fontSize: theme.fontSize.small,
          fontWeight: 400,
          color: source === SubscriptionSource.TRIAL_REQUEST
            ? theme.refV2.cat.purple[100]
            : theme.refV2.sem.green[100],
        },
      })}
    />
  ) : renderBillingCycle(source, billingInterval);
};
